import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gallery";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6 md:py-16">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-sun-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-semibold text-background-50">橘海同人馆</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200/80">
            专注整理娜美同人插画、高清壁纸与画师画集,持续上新,满足你的收藏与欣赏需求。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">快速导航</h4>
          <ul className="mt-4 space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-sm text-background-200/80 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">内容分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
            <li><a href="#works" className="hover:text-primary-300 cursor-pointer">插画精选</a></li>
            <li><a href="#works" className="hover:text-primary-300 cursor-pointer">高清壁纸</a></li>
            <li><a href="#collections" className="hover:text-primary-300 cursor-pointer">系列画集</a></li>
            <li><a href="#artists" className="hover:text-primary-300 cursor-pointer">画师专栏</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              hello@orange-gallery.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              每周定期上新
            </li>
          </ul>
          <div className="mt-4 flex items-center gap-3">
            <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 cursor-pointer">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 cursor-pointer">
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-200/60 sm:flex-row md:px-6">
          <p>© 2026 橘海同人馆 · 所有作品版权归原作者所有,仅供个人欣赏。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-400"></i>
            用心收藏每一份热爱
          </p>
        </div>
      </div>

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:-translate-y-1 cursor-pointer"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}
    </footer>
  );
}